import React from "react";
import { Navbar as BootstrapNavbar, Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useNavigate } from "react-router-dom";

const NavBar = () => {


  const navigate = useNavigate();

  const logout = () =>{
    localStorage.removeItem('token');
    navigate(`/login`);  
  }


  return (
    <BootstrapNavbar bg="dark" variant="dark" expand="lg" className="px-5">
      <LinkContainer to={"/dashboard"}>
        <BootstrapNavbar.Brand>Grand CMS</BootstrapNavbar.Brand>
      </LinkContainer>
      <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />
      <BootstrapNavbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto">

          <LinkContainer to={"/dashboard/quiz"}>
            <Nav.Link>Pregled kviza</Nav.Link>
          </LinkContainer>

          {/*<LinkContainer to={"/dashboard/view"}>
            <Nav.Link>Pregled računa</Nav.Link>
  </LinkContainer>*/}

          <div className="logout" onClick={logout}>LOGOUT</div>

        </Nav>
      </BootstrapNavbar.Collapse>

      
    </BootstrapNavbar>
  );
};

export default NavBar;
